// P-12 · lógica pura de permisos del panel.
//
// A partir del usuario que devuelve el backend (user.access[] con profile_id),
// decide si puede EDITAR (perfil admin) o es de SOLO LECTURA (perfil viewer).
// El refuerzo REAL está en el backend (middleware CheckAdminOrViewer): esto solo
// gobierna la capa visual (banner "solo lectura" + ocultar botones de acción).

export const ADMIN_PROFILE_ID = 1;
export const VIEWER_PROFILE_ID = 3;

interface Access {
    profile_id?: number | string;
    profile?: string;
}

interface UserLike {
    access?: Access[];
}

export function hasProfile(user: UserLike | null | undefined, profileId: number): boolean {
    if (!user || !Array.isArray(user.access)) {
        return false;
    }
    return user.access.some((a) => Number(a.profile_id) === profileId);
}

/** Puede editar (crear/guardar/borrar) solo quien tenga el perfil admin. */
export function canEdit(user: UserLike | null | undefined): boolean {
    return hasProfile(user, ADMIN_PROFILE_ID);
}

/** Es de solo lectura quien tiene el perfil viewer y NO es admin. */
export function isViewer(user: UserLike | null | undefined): boolean {
    return hasProfile(user, VIEWER_PROFILE_ID) && !canEdit(user);
}
